import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { InAppReview } from '@capacitor-community/in-app-review';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SafeArea } from '@capacitor-community/safe-area';
import { IS_ANDROID_APP } from './Constants';

export const appInfo = {
	version: '0',
	build: '0',
};

export const loadAppInfo = async () => {
	const { version, build } = await App.getInfo();
	appInfo.version = version;
	appInfo.build = build;
};

export const handleBrowserOpen = () => {
	window.open = async (url, target = '_blank') => {
		if (Capacitor.isNativePlatform()) {
			await Browser.open({ url });
		} else {
			window.open(url, target);
		}
	};
};

export const requestAppReview = async () => {
	try {
		await InAppReview.requestReview();
	} catch (error) {
		console.error('Error requesting native In-App Review:', error);
	}
};

export const updateStatusBar = (themeKey) => {
	const isLightTheme = themeKey === 'light';
	const styleKey = isLightTheme ? 'Light' : 'Dark';
	const barContent = isLightTheme ? 'dark' : 'light';

	(async () => {
		try {
			await StatusBar?.setStyle({ style: Style[styleKey] });

			if (IS_ANDROID_APP) {
				await SafeArea.enable({
					config: {
						customColorsForSystemBars: true,
						statusBarColor: '#00000000',
						navigationBarColor:'#00000000',
						statusBarContent: barContent
					},
				});
			}
		} catch (err) {
			console.log('Failed to update status bar:', err);
		}
	})();
};
